import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { benchmarkkpi, tranbenchmarkkpi, practicebmtransactionadd, BMProjectActions } from './../../../../models/slakpi';
import { division, user, department, targetMaster, performancemaster, benchmarkprogressmaster } from './../../../../models/admin';
import { UtilityService } from '../../../../services/utility.service';
import { BMApiService } from '../../../../services/bm.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from '../../../../services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';

import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminApiService } from '../../../../services/admin.service';
import { formatDate } from '@angular/common';
import { ToasterService } from '../../../../toaster.service';
import { Undefined } from '@alyle/ui';

@Component({
  selector: 'app-practice-bm-progress-transaction-add',
  templateUrl: './practice-bm-progress-transaction-add.component.html',
  styleUrls: ['./practice-bm-progress-transaction-add.component.css']
})
export class PracticeBMProgressTransactionAddComponent implements OnInit {
  @ViewChild('assignUserTemplate', { static: false }) assignUserTemplate: TemplateRef<any>;
  modalRef: BsModalRef;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  public selTab = true;
  public data: any;
  public gridload: number = 0;
  public division_data: any;
  public department_data: any;
  public kpiTypeUno_data: any;
  public target_data: any;
  public mindate: any;
  public trend_data: any;
  public condition2_data: any;
  public slaStatusRule_data: any;
  public dataEntry_data: any;
  public user_data: any;
  public dataEntry_data_filter: any;
  public user_data_filter: any;

  public selected_kpiCode: string = '';

  submitted: boolean = false;
  benmarksubmitted: boolean = false;
  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  public divisionUno_filter: number = 0;
  public objPM: any = new practicebmtransactionadd();
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  angularGrid: AngularGridInstance;
  //For Filter

  public benchMarkYear_data: any;
  public source_data: any;
  public peer_data: any;
  public consideration_data: any;
  public selectedItemID: any;
  public isTranData: boolean = false;
  peerTypeDDList: any;
  isProject: boolean = false;
  public oneColumn1List: any = [];
  public projects_data: any = [];
  projects_data_search: any = [];
  planValue: any;
  collectValue: any;
  analyseValue: any;
  adaptValue: any;
  progressTypeList: any;
  radioButtonValue: any = 5;
  projectID: any;
  bmProgressMasterData: any[];
  progressTypeValue: any;
  public percentageTotal: any;
  projectProgressTotal: any = 0;
  bmProgressProjectList: Object;
  progressbtn = "Save";
  projectActionsList: any = [];

  objProgressMaster: any = new benchmarkprogressmaster();
  assinedUserList = [{ value: 0, text: 'BMChampions' }, { value: 1, text: 'BMTeam' }];
  statusList = [{ value: 1, text: 'InProgress' }, { value: 2, text: 'OnHold' }, { value: 3, text: 'Approved' }];
  corporateStrategicList = [{ value: 1, text: 'Corporate Strategic 1' }, { value: 2, text: 'Corporate Strategic 2' }, { value: 3, text: 'Corporate Strategic 3' }];
  assignUser: any;
  bmProgressItemUno: any;
  startDate: any
  endDate: any;
  itemUno: any;
  isStatus = false;
  progressItemList: any = [];
  assignUserList: any = [];
  projectList: any = [];
   public  date = new Date;
  
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
    planTotalPercentage: any;
    collectTotalPercentage: any;
    adaptTotalPercentage: any;
    analyseTotalPercentage: any;
    tenantUno: any;
  constructor(private formBuilder: FormBuilder, public restApi: BMApiService, private toaster: ToasterService, private route: ActivatedRoute, public restAdminApi: AdminApiService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();

   
  }
  //Method used To Validate User Permission
  ValidateUserAccess() {
    
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Practice Benchmark Setup");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }
  ngOnInit() {
    this.userService.CheckLogin();
    //this.modalRef.hide();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 5
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 1,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.route
      .queryParams
      .subscribe(params => {
        let itemUno = params['itemUno'];
        itemUno = (itemUno != undefined && itemUno != null) ? itemUno : 0;
        
        if (itemUno != undefined && itemUno != null && itemUno != 0) {
          this.itemUno = itemUno;
          this.projectID = itemUno;
          this.progressbtn = "Update";
          this.getBMProgressProjects(itemUno);
          this.getBMProgressProjectActions(itemUno);
          this.isProject = true;
          this.isStatus = true;
          this.getDivisions();
          this.getUsers();
          this.getPeerTypeDD();
          this.loadPerformanceMaster(5);
          this.getProjects();

        }
        else {
          this.progressbtn = "Save";
          this.getDivisions();
          this.getUsers();
          this.isProject = false;
          this.getPeerTypeDD();
          this.getProjects();
          this.getBMProgressProjects(itemUno);
        }
      });

    this.setMindate();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  getPeerTypeDD() {

    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restAdminApi.GetPeerTypeDD(inpValue)
      .subscribe(data => {

        this.peerTypeDDList = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  Reset() {
    this.router.navigate(['/practice-bm-progress-transaction-list']);
  }

  getUsers() {

    let inpValue = new user();
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    this.restApi.getUsers(inpValue)
      .subscribe(data => {
        
        this.user_data = data;
        this.dataEntry_data = data;
        this.user_data_filter = data;
        this.dataEntry_data_filter = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {

        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getProjects() {

    let inpValue = new benchmarkprogressmaster();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    this.restAdminApi.getBMProgressMaster(inpValue)
      .subscribe(data => {

        this.projects_data = data;
        if (this.progressbtn == 'Save') {

          this.progressTypeList = this.projects_data.filter(a => a.bmProgressTypeUno == 5);
          this.projects_data_search = this.progressTypeList;
        }
        else if (this.progressbtn == 'Update') {
          let itemCollection: any = [];
          //for (let i = 0; this.progressItemList.length > 0; i++) {
          //  let arrayList = this.projects_data.filter(a => a.id != this.progressItemList[i].bmProgressUno);
          //  itemCollection.push(arrayList);
          //}
          //this.progressTypeList = itemCollection;
          //this.projects_data_search = this.progressTypeList;
          this.progressTypeList = this.projects_data.filter(a => a.bmProgressTypeUno == 5);
          this.projects_data_search = this.progressTypeList;
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  loadPerformanceMaster(value: any) {
    
    this.progressTypeValue = value;
    let valuePer: any = [];
    this.spinner.show();
    let inpValue = new BMProjectActions();
    inpValue.languageUno = 1033;
    inpValue.itemUno = (this.progressbtn == "Save") ? this.projectID : this.itemUno;
    inpValue.condition = 3;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getProjectActions(inpValue)
      .subscribe(data => {
        

        let filterDataSet = [];
        filterDataSet = uniqBy(data, 'id');
        this.progressItemList = filterDataSet;
        this.data = filterDataSet.filter(a => a.bmProgressItemUno == value);


        let planper = filterDataSet.filter(a => a.bmProgressItemUno == 5);
        this.planTotalPercentage = planper.reduce((a, b) => a + b.percentage, 0);
        let collectper = filterDataSet.filter(a => a.bmProgressItemUno == 6);
        this.collectTotalPercentage = collectper.reduce((a, b) => a + b.percentage, 0);
        let adaptper = filterDataSet.filter(a => a.bmProgressItemUno == 8);
        this.adaptTotalPercentage = adaptper.reduce((a, b) => a + b.percentage, 0);
        let analyzeper = filterDataSet.filter(a => a.bmProgressItemUno == 7);
        this.analyseTotalPercentage = analyzeper.reduce((a, b) => a + b.percentage, 0);


        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {

          mockDataset[i] = {
            id: this.data[i].id,
            bmProgressName: this.data[i].bmProgressName,
            bmProgressItemUno: this.data[i].bmProgressItemUno,
            percentage: this.data[i].percentage + '%',
            assignedUser: this.data[i].assignedUser,
            progressStatus: this.data[i].progressStatus,
            assignedUserName: this.data[i].assinedUserName,
            startDate: this.data[i].startDate.substring(0, 10),
            endDate: this.data[i].endDate.substring(0, 10)


          };


          valuePer.push(this.data[i].percentage)
        }

        this.percentageTotal = valuePer.reduce((a, b) => a + b, 0);

        //document.getElementById("planprogress").style.width = this.percentageTotal + "%";
        this.dataset = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridBMProgressDefn();
        }
        else {
          this.setGridBMProgressDefn();
        }
        this.bmProgressMasterData = mockDataset;
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  setGridBMProgressDefn() {
    let temp = this;
    this.columnDefinitions = [

      {
        id: 'bmProgressName', name: 'Task Name', field: 'bmProgressName', sortable: true, type: FieldType.string, filterable: false,width:200,

      },
      {
        id: 'assignedUserName', name: 'Assigned User', field: 'assignedUserName', sortable: true, type: FieldType.string, filterable: false, width: 100,

      },
      {
        id: 'startDate', name: 'Start Date', field: 'startDate', sortable: true, type: FieldType.string, filterable: false, width: 40,

      },
      {
        id: 'endDate', name: 'End Date', field: 'endDate', sortable: true, type: FieldType.string, filterable: false, width: 40,

      },
      {
        id: 'bmProgressValue', name: 'Percentage', field: 'percentage', sortable: true, type: FieldType.string, filterable: false, width: 10,

      },
      {
        id: 'progressStatus', name: 'Progress', field: 'progressStatus', sortable: true, type: FieldType.string, filterable: false, width: 10,

      },

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 10,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Assign',
              iconCssClass: 'fa fa-user', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                
                let rdata: any = args.dataContext;
                this.bmProgressItemUno = rdata.id;
                if (this.objPM.projectMember != null && this.objPM.projectMember != undefined && this.objPM.projectMember != '') {
                  this.assignUserList = this.user_data_filter.filter(a => this.objPM.projectMember.includes(a.userUno));
                }
                else {
                  this.assignUserList = [];
                }
                this.endDate = '';
                this.startDate = '';
                this.assignUser = '';
                this.selTab = true;
                this.modalRef = this.modalService.show(
                  this.assignUserTemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeleteProgressBenchMarkProjectActions(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }

    ]


  }

  DeletePerformanceMaster(data1: any) {
    
    let objpfm = new benchmarkprogressmaster();
    objpfm.actionType = this.pageAction;
    objpfm.id = data1.id;
    objpfm.userUno = this.login_UserID;
    objpfm.tenantUno = this.tenantUno;
    //objpfm.tableName = this.pfmType;
    this.restAdminApi.deleteBMProgressMaster(objpfm)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '' && data != 'failure') {
        
          this.toaster.show('success', 'Success', 'Item deleted.');
          this.loadPerformanceMaster(this.progressTypeValue);
        }
        else {
        
          //this.toaster.show('success', 'Success', 'Something went wrong.');
          this.toaster.show('error', 'Error', 'Something went wrong');
         
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  onRadioButtonChange(value: any) {
    this.oneColumn1List = [];
    this.radioButtonValue = value;
    this.progressTypeList = this.projects_data.filter(a => a.bmProgressTypeUno == value);
    this.projects_data_search = this.progressTypeList;
    //if (this.progressbtn == 'Save') {
    //  this.progressTypeList = this.projects_data.filter(a => a.bmProgressTypeUno == value);
    //}
    //else if (this.progressbtn == 'Update') {
    //  let collectionList: any = [];
    //  for (let i = 0; i < this.projectActionsList.length; i++) {
    //    let ItemList = this.projects_data.filter(a => a.bmProgressTypeUno == value && a.id != this.projectActionsList[i].bmProgressUno);
    //    collectionList.push(ItemList);
    //  }
    //  this.progressTypeList = collectionList;
    //  this.projects_data_search = this.progressTypeList;
    //}
  }

  DuplicateNameCheck(itemUno: number, nameEn: string, nameAr: string) {
    
    if (this.projectList != null && this.projectList != undefined) {
      var rtnValue = false;
      this.projectList.forEach((grdData) => {
        if (((itemUno != grdData.id) || (itemUno == grdData.id && this.itemUno != grdData.id))
          &&
          (grdData.projectName.toLocaleLowerCase() == nameEn.trim().toLowerCase())) {
          rtnValue = true;
        }



      });

      return rtnValue;
    }
  }
  
  onSubmit(val1) {
    
    this.submitted = true;
    
    if (!val1) {
      //Swal.fire('Error', 'Please enter the required information.', 'error');
      this.toaster.show('error', 'Error', 'Please enter the required information.');
      return
    }

    else {
      this.submitted = false;
      this.AddEditBMProject(this.objPM);
    }
  }

  AddEditBMProject(data:any) {
    
    if (this.DuplicateNameCheck(this.utilityService.isNumericNull(this.itemUno), this.utilityService.isStringNull(data.projectName), this.utilityService.isStringNull(data.projectName))) {
      //Swal.fire('Error', 'Duplicates are not allowed', 'warning');
      this.toaster.show('warning', 'Warning', 'Project name already exists');
      return false;
    }
    //if (this.objPM.plannedStartDate && this.objPM.plannedStartDate > this.objPM.plannedEndDate) {
    //  this.toaster.show('error', 'Error', 'Planned Start date should be lesser than Planned End date');

    //  return;
    //}
    //if (this.objPM.plannedStartDate && this.objPM.plannedEndDate && this.objPM.plannedStartDate > this.objPM.plannedEndDate) {
    //  this.toaster.show('error', 'Error', 'Planned Start date should be lesser than Planned End date');

    //  return;
    //}

    if (this.compareDate(this.objPM.plannedStartDate, this.objPM.plannedEndDate)) {
      this.toaster.show('error', 'Error', 'Planned Start date should be lesser than Planned End date');
      return;
    }
    let currentDate = new Date();
    let sDatesplit = this.objPM.plannedStartDate.split('-');
    let startDate = new Date(sDatesplit[0], sDatesplit[1] - 1, sDatesplit[0]);
    //if (this.objPM.plannedStartDate && startDate >= currentDate) {
    //  this.toaster.show('error', 'Error', 'Start date should be lesser than current date');

    //  return;
    //}
    let obj = new practicebmtransactionadd();
    obj.id = (this.itemUno != undefined && this.itemUno != null) ? this.itemUno : 0;
    obj.projectName = (this.objPM.projectName) ? this.objPM.projectName.toString() : '';
    obj.division = (this.objPM.division) ? this.objPM.division.toString() : '';
    obj.projectManager = (this.objPM.projectManager) ? this.objPM.projectManager.toString() : '';
    obj.peer = (this.objPM.peer) ? this.objPM.peer.toString() : '';
    obj.comments = (this.objPM.comments) ? this.objPM.comments.toString() : '';
    obj.status = "Draft"
    obj.plannedStartDate = this.objPM.plannedStartDate;
    obj.plannedEndDate = this.objPM.plannedEndDate;
    obj.userUno = this.login_UserID;
    obj.tenantUno = this.tenantUno;
    // obj.actionType = this.pageAction;
    // obj.kpiUno = (this.pageAction == "add") ? 0 : this.utilityService.isNumericNull(data1.kpiUno);
    obj.condition = (!this.isTranData) ? 0 : 1;
    obj.projectMember = (this.objPM.projectMember) ? this.objPM.projectMember.toString() : '';
    obj.corporateStrategic = (this.objPM.corporateStrategic) ? this.objPM.corporateStrategic.toString() : '';
    obj.level1ApproverUno = (this.objPM.level1ApproverUno) ? this.objPM.level1ApproverUno.toString() : '';
    obj.level2ApproverUno = (this.objPM.level2ApproverUno) ? this.objPM.level2ApproverUno.toString() : '';
    obj.level3ApproverUno = (this.objPM.level3ApproverUno) ? this.objPM.level3ApproverUno.toString() : '';
    this.restApi.addEditPracticeBMProgress(obj)
      .subscribe(data => {

        if (data != null && data != undefined && data != '' && data != 'failure') {
          this.projectID = data;
          if (this.progressbtn == "Save" ) {
            this.itemUno = data;
          }
          else if (this.progressbtn == "Update") {
            this.itemUno = this.itemUno;
          }
          
          this.getProjects();
         
          this.toaster.show('success', 'Success', 'Item Saved.');
          this.oneColumn1List = [];
          this.isProject = true;
          this.isStatus = true;
          this.progressbtn = "Update";
          
         
          this.progressTypeList = this.projects_data.filter(a => a.bmProgressTypeUno == 1);
          this.projects_data_search = this.progressTypeList;
          // this.modalRef.hide();
          setTimeout(() => { this.spinner.hide();; }, 900);
        }
        else {
         /// Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
          this.isProject = false;

          this.isStatus = false;
        }
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;
    //}
  }

 

  DeleteProgressBenchMarkProjectActions(data1: any) {
    
    let objBenchmark = new BMProjectActions();
    objBenchmark.id = data1.id;
    objBenchmark.userUno = this.login_UserID;
    objBenchmark.tenantUno = this.tenantUno;

    this.restApi.deleteProgressBMProjectAction(objBenchmark)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '' ) {
         // Swal.fire('Error', 'Something went wrong!', 'error')

          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          this.toaster.show('success', 'Success', 'Item Deleted.');
          this.loadPerformanceMaster(this.progressTypeValue);
          this.getProjects();
          this.getBMProgressProjectActions(this.projectID);
         
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  public focusIn(target: HTMLElement): void {
    target.parentElement.classList.add('e-input-focus');
  }

  public focusOut(target: HTMLElement): void {
    target.parentElement.classList.remove('e-input-focus');
  }

  openModalWithClass(addtemplate: TemplateRef<any>) {
    this.pageAction == "add";
    this.objPM = new practicebmtransactionadd();
    this.selTab = true;
    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  getBooleanValue(checkboxSelector) {
    return document.querySelector(checkboxSelector).checked;
  }

  onNext(val) {
    if (val) {
      this.selTab = false;
    }
    else {
      Swal.fire('Error', 'Please enter the General Information.', 'error')

    }
  }

  drop(event: CdkDragDrop<string[]>) {
    


    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

    }
    else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);

    }

  }

  dragdrop(event: CdkDragDrop<string[]>) {
    


    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

    }
    else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);



    }
  }

  searchItems() {
    
    let searchText = (<HTMLInputElement>document.getElementById('modalSearch')).value;
    this.projects_data_search = this.projects_data.filter(a => a.bmProgressTypeUno == this.radioButtonValue);
    this.progressTypeList = this.projects_data_search.filter(item => item.bmProgressName.toLowerCase().indexOf(searchText.toLowerCase()) > -1);


  }

  addBMProjectActions() {
    
    let progressID: any;
    let idList: any = [];
    let percentageTotal: any = [];
    let progressProjectIDs: any;
    if (this.oneColumn1List.length == 0) {
      this.toaster.show('error', 'Error','Please enter the required information.');
      return
    }
   
    for (let i = 0; i < this.oneColumn1List.length; i++) {

      progressID = this.oneColumn1List[i].id;
      percentageTotal.push(this.oneColumn1List[i].bmProgressValue);
      idList.push(progressID);
    }
    let total: any;
    total = percentageTotal.reduce((a, b) => a + b, 0);
    let limitCheck = total + this.projectProgressTotal;
    if (limitCheck > 100) {

    //  Swal.fire('Error', 'Project Progress Value only below 100%', 'warning');
      this.toaster.show('error', 'Error', 'Project progress value should not exceeds 100%"');
      return false;
    }
    progressProjectIDs = idList.toString();
    let obj = new practicebmtransactionadd();

    obj.projectUno = this.projectID;
    obj.bmProgressUno = (progressProjectIDs) ? progressProjectIDs : '';
    obj.userUno = this.login_UserID;
    obj.tenantUno = this.tenantUno;
    obj.bmProgressItemUno = this.radioButtonValue;
    obj.condition = (!this.isTranData) ? 0 : 1;
    this.restApi.addBMProjectActions(obj)
      .subscribe(data => {

        if (data != null && data != undefined && data != '' && data != 'failure') {
        
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
          //this.isProject = false;
        }
        else {

          this.getProjects();
          this.loadPerformanceMaster(this.projectID)
          let projectTotalPer: any = [];
          for (let i = 0; i < this.oneColumn1List.length; i++) {
            projectTotalPer.push(this.oneColumn1List[i].bmProgressValue);
          }
          let total: any
          total = projectTotalPer.reduce((a, b) => a + b, 0);
          this.projectProgressTotal = total + this.projectProgressTotal;
          this.oneColumn1List = [];
          this.toaster.show('success', 'Success', 'Item Added.');

          // this.modalRef.hide();
          setTimeout(() => { this.spinner.hide();; }, 900);
        }
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;
    //}
  }

  getBMProgressProjects(id: any) {
  
    let inpValue = new practicebmtransactionadd();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = id;
    inpValue.condition = (id == 0) ? 1 : 2;
    inpValue.tenantUno = this.tenantUno;
    inpValue.flag = 'Setup';
    this.restApi.getProjects(inpValue)
      .subscribe(data => {
        //  this.objPM = data;
        this.projectList = data;
        if (id != 0) {
        this.objPM.projectName = data[0].projectName;
        this.objPM.comments = data[0].comments;
        this.objPM.peer = data[0].peerUno;
        this.objPM.division = data[0].divisionUno;
        this.objPM.projectManager = data[0].projectManagerUno;
        this.objPM.projectMember = (data[0].projectMember) ? this.utilityService.CommaSeperatorToArray(data[0].projectMember.toString()) : [];
        this.objPM.corporateStrategic = (data[0].corporateStrategic) ? this.utilityService.CommaSeperatorToArray(data[0].corporateStrategic.toString()) : [];
        this.objPM.level1ApproverUno = (data[0].level1ApproverUno) ? this.utilityService.CommaSeperatorToArray(data[0].level1ApproverUno.toString()) : [];
        this.objPM.level2ApproverUno = (data[0].level2ApproverUno) ? this.utilityService.CommaSeperatorToArray(data[0].level2ApproverUno.toString()) : [];
        this.objPM.level3ApproverUno = (data[0].level3ApproverUno) ? this.utilityService.CommaSeperatorToArray(data[0].level3ApproverUno.toString()) : [];
        this.objPM.plannedStartDate = formatDate(data[0].plannedStartDate, 'yyyy-MM-dd', 'en-US');
          this.objPM.plannedEndDate = formatDate(data[0].plannedEndDate, 'yyyy-MM-dd', 'en-US');
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getBMProgressProjectActions(id: any) {

    let inpValue = new BMProjectActions();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = id;
    inpValue.condition = 3;
    inpValue.tenantUno = 1;
    this.restApi.getProjectActions(inpValue)
      .subscribe(data => {
        if (data != '' && data != null && data != undefined) {
          this.projectActionsList = data;

          let percentage: any = [];
          for (let i = 0; i < this.projectActionsList.length; i++) {
            percentage.push(this.projectActionsList[i].percentage);
          }
          this.projectProgressTotal = percentage.reduce((a, b) => a + b, 0);
        }
        else {
          this.oneColumn1List = [];
        }

      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  onAssignUserSubmit(val) {
    
    if (!val) {
      //Swal.fire('Error', 'Please enter the required information.', 'error');
      this.toaster.show('error', 'Error', 'Please enter the required information.');
      return
    }

    else {
      this.assignUserUpdate();
    }
  }
  assignUserUpdate() {
    
    if (this.startDate && this.endDate&&this.startDate > this.endDate) {
      this.toaster.show('error', 'Error', 'Start date should be lesser than end date');
     
      return;
    }
    let obj = new benchmarkprogressmaster();
    obj.id = this.bmProgressItemUno;
    obj.assignUsers = (this.assignUser) ? this.assignUser.toString() : '';
    obj.startDate = this.startDate;
    obj.endDate = this.endDate;
    obj.userUno = this.login_UserID;
    obj.tenantUno = this.tenantUno;
    obj.condition = (!this.isTranData) ? 0 : 1;
    this.restApi.assignUserUpdate(obj)
      .subscribe(data => {

        if (data == 'failure') {
        //  Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();

        }
        else {
          this.toaster.show('success', 'Success', 'Users Assigned Successfully.');
          this.loadPerformanceMaster(this.progressTypeValue);
          this.assignUser = '';
          this.modalRef.hide();
          // this.modalRef.hide();
          setTimeout(() => { this.spinner.hide();; }, 900);

        }
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;
    //}
  }
  onStatusChanged() {
    
    if ((this.objPM.projectMember != null && this.objPM.projectMember != undefined && this.objPM.projectMember != '') && (this.objPM.level1ApproverUno != null && this.objPM.level1ApproverUno != undefined && this.objPM.level1ApproverUno != '') && (this.objPM.level2ApproverUno != null && this.objPM.level2ApproverUno != undefined && this.objPM.level2ApproverUno != '') && (this.objPM.level3ApproverUno != null && this.objPM.level3ApproverUno != undefined && this.objPM.level3ApproverUno != '')) {


      if (this.projectProgressTotal == 100) {
        let planLength = this.progressItemList.filter(a => a.bmProgressItemUno == 5).length;
        let collectLength = this.progressItemList.filter(a => a.bmProgressItemUno == 6).length;
        let analyseLength = this.progressItemList.filter(a => a.bmProgressItemUno == 7).length;
        let adaptLength = this.progressItemList.filter(a => a.bmProgressItemUno == 8).length;
        if (planLength > 0 && collectLength > 0 && analyseLength > 0 && adaptLength > 0) {

          let planList = this.progressItemList.filter(a => a.bmProgressItemUno == 5);
          let collectList = this.progressItemList.filter(a => a.bmProgressItemUno == 6);
          let analyseList = this.progressItemList.filter(a => a.bmProgressItemUno == 7);
          let adaptList = this.progressItemList.filter(a => a.bmProgressItemUno == 8);
          let planassignUserLength = planList.filter(a => a.assignedUser == '').length;
          let collectassignUserLength = collectList.filter(a => a.assignedUser == '').length;
          let analyseassignUserLength = analyseList.filter(a => a.assignedUser == '').length;
          let adaptassignUserLength = adaptList.filter(a => a.assignedUser == '').length;

          if (planassignUserLength > 0 || collectassignUserLength > 0 || analyseassignUserLength > 0 || adaptassignUserLength > 0) {
            //Swal.fire('Error', 'Compulsory One Assined User', 'error');
            this.toaster.show('error', 'Error', 'Assign atleast one user');

          }
          else {

            let obj = new practicebmtransactionadd();
            obj.id = (this.itemUno != undefined && this.itemUno != null) ? this.itemUno : this.projectID;
            obj.projectName = (this.objPM.projectName) ? this.objPM.projectName.toString() : '';
            obj.division = (this.objPM.division) ? this.objPM.division.toString() : '';
            obj.projectManager = (this.objPM.projectManager) ? this.objPM.projectManager.toString() : '';
            obj.peer = (this.objPM.peer) ? this.objPM.peer.toString() : '';
            obj.comments = (this.objPM.comments) ? this.objPM.comments.toString() : '';
            obj.status = "Approval 1";
            obj.plannedStartDate = this.objPM.plannedStartDate;
            obj.plannedEndDate = this.objPM.plannedEndDate;
            obj.userUno = this.login_UserID;
            obj.tenantUno = this.tenantUno;
            // obj.actionType = this.pageAction;
            // obj.kpiUno = (this.pageAction == "add") ? 0 : this.utilityService.isNumericNull(data1.kpiUno);
            obj.condition = (!this.isTranData) ? 0 : 1;
            obj.projectMember = (this.objPM.projectMember) ? this.objPM.projectMember.toString() : '';
            obj.corporateStrategic = (this.objPM.corporateStrategic) ? this.objPM.corporateStrategic.toString() : '';
            obj.level1ApproverUno = (this.objPM.level1ApproverUno) ? this.objPM.level1ApproverUno.toString() : '';
            obj.level2ApproverUno = (this.objPM.level2ApproverUno) ? this.objPM.level2ApproverUno.toString() : '';
            obj.level3ApproverUno = (this.objPM.level3ApproverUno) ? this.objPM.level3ApproverUno.toString() : '';
            this.restApi.addEditPracticeBMProgress(obj)
              .subscribe(data => {

                if (data != null && data != undefined && data != '') {

                  setTimeout(() => { this.spinner.hide();; }, 900);
                  this.router.navigate(['/practice-bm-progress-transaction-list']);
                  return false;
                }
                else {
                  Swal.fire('Error', 'Something went wrong', 'error');
                  this.spinner.hide();

                }
              },
                (error) => {
                  //Called when error
                  this.spinner.hide();
                }
              ).add(() => {
                //Called when operation is complete (both success and error)
                //this.spinner.hide();
              });
            return true;
          }
        }
        else {
          //Swal.fire('Error', 'Compulsory One Data', 'error');
          this.toaster.show('error', 'Error', 'Assign atleast one user');
        }
      }
      else {
        // Swal.fire('Error', 'Project Percentage Please 100% Complete', 'error');
        this.toaster.show('error', 'Error', 'Project percentage is lesser than 100%');
      }
    }
      else {
        this.toaster.show('error', 'Error', 'Please insert approvers and project member fileds next move to send for approval');
        return false;
      }
  }
  setMindate() {
    let dtToday = new Date();

    let month: any = dtToday.getMonth() + 1;
    let day: any = dtToday.getDate();
    let year: any = dtToday.getFullYear();
    if (month < 10)
      month = '0' + month.toString();
    if (day < 10)
      day = '0' + day.toString();

    let maxDate: any = year + '-' + month + '-' + day;
    
    //let element = document.getElementById('receivedOn');
    //element.setAttribute('min', maxDate);

    this.mindate = maxDate;
  }

  //Compare Two Dates
  compareDate(startDate:any,endDate:any) {
    //var d1 = new Date('2020-01-23'); //yyyy-mm-dd  
    //var d2 = new Date('2020-01-21'); //yyyy-mm-dd
    let returnValue: boolean = false;
    let d1 = new Date(startDate);
    let d2 = new Date(endDate);
    if (d1 > d2) {
      returnValue = true;
    }

    return returnValue;
  }
}
